import { defineStore } from "pinia"
import { reactive } from "vue"

interface TimestampState {
	timestamps: Timestamp[]
}

interface Timestamp {
	id: number
	type: string
	timestamp: number
}

export const useTimestampStore = defineStore("useTimestampsStore", () => {
	const state = reactive<TimestampState>({
		timestamps: [],
	})

	const addTimestamp = (timestamp: number, type: string, id: number) => {
		const existingIndex = state.timestamps.findIndex((t) => t.id === id)
		if (existingIndex !== -1) {
			state.timestamps[existingIndex] = { id, type, timestamp }
		} else {
			state.timestamps.push({ id, type, timestamp })
		}
	}
	return { state, addTimestamp }
})
